/**
 * La fila de un catálogo que corresponde a un valor leído del documento.
 *
 * Lo que llega puede ser el id de la fila (el domicilio ya viene resuelto
 * contra el mismo catálogo), su nombre, o las primeras letras de su nombre.
 * La nacionalidad del MRZ (ARG) ya no se resuelve acá: se elige por el código
 * del país (`filaDeNacionalidad`, en nacionalidad.ts). El prefijo es solo el
 * respaldo para los catálogos sin códigos, y vale únicamente cuando elige UNA
 * fila: si empiezan igual dos o más (argelina y argentina para «ARG») no se
 * devuelve ninguna. Lo que no se encuentra, o no se puede distinguir, no se
 * devuelve: es preferible dejar el campo como estaba a llenarlo con la fila
 * equivocada.
 */
export interface FilaDeCatalogo {
  id: string;
  displayId: string;
}

export function buscarOpcion<T extends FilaDeCatalogo>(
  opciones: readonly T[] | undefined,
  valor: unknown
): T | undefined {
  if (!opciones || valor === null || valor === undefined || valor === "") return undefined;
  const buscado = String(valor).toUpperCase();
  return (
    opciones.find((o) => o.id === valor) ??
    opciones.find((o) => o.displayId.toUpperCase() === buscado) ??
    unicaPorPrefijo(opciones, buscado)
  );
}

/** La fila que empieza con `buscado`, solo si es la única que empieza así. */
function unicaPorPrefijo<T extends FilaDeCatalogo>(
  opciones: readonly T[],
  buscado: string
): T | undefined {
  if (buscado.length < 3) return undefined;
  const candidatas = opciones.filter((o) => o.displayId.toUpperCase().startsWith(buscado));
  return candidatas.length === 1 ? candidatas[0] : undefined;
}
